module.exports = __webpack_public_path__ + "static/crm-a4764627245c1b6f5f5a9fa1612c21f3.png";